import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { KeyValue } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import {
  Consultation,
  INote,
  IOrder,
  ISubscription,
  Note
} from '@care-portals/api-interfaces';
import { NoteFacade } from '../../+store/note/note.facade';
import { Dictionary } from '@ngrx/entity/src/models';

@Component({
  selector: 'portals-emr-notes-list',
  templateUrl: './notes.component.html',
  styleUrls: ['./notes.component.less']
})
export class NotesComponent implements OnInit, OnDestroy {
  @Input() consultation: Consultation;
  @Input() order: IOrder;
  @Input() subscription: ISubscription;
  @Input() label: string = '';
  notes$: Observable<Dictionary<Note>>;
  totalCount$: Observable<number>;
  addable = false;
  isActive = true;
  constructor(
    public activatedRoute: ActivatedRoute,
    public facade: NoteFacade
  ) {}

  ngOnInit() {
    this.notes$ = this.facade.notes$;
    this.totalCount$ = this.facade.totalCount$;
    const filter: Partial<INote> = {};
    if (this.consultation) {
      filter.consultation = this.consultation._id;
    } else if (this.order) {
      filter.order = this.order._id;
    } else if (this.subscription) {
      filter.subscription = this.subscription._id;
    }

    this.facade.loadNotes({
      ...filter
    });
  }

  ngOnDestroy(): void {
    this.isActive = false;
  }

  noteOrder = (
    a: KeyValue<string, Note>,
    b: KeyValue<string, Note>
  ): number => {
    return a.value.createdAt < b.value.createdAt ? 1 : -1;
  };

  closeComposer() {
    this.addable = false;
  }
}
